module.exports = __webpack_public_path__ + "static/account-management-screenshot@2x-86365f02c5dba9c9b3556c7fe4e1716f.png";